module.exports = __webpack_public_path__ + "assets/download-white.9a1669a06fac2972118a30a82059e359.svg";